// @ts-nocheck
import Vue from 'vue'
import Router from 'vue-router'
import AppRoot from '@/layouts/AppRoot.vue'

import Home from '@/pages/Index.vue'
import Logout from '@/pages/Logout.vue'
import Error from '@/pages/Error.vue'

import Patients from '@/pages/patients/Index.vue'
import DetailedPatient from '@/pages/patients/_patient_id/Index.vue'
import EditDetailedPatient from '@/pages/patients/_patient_id/Edit.vue'
import PatientReport from '@/pages/patient-report/_patient_id/Index.vue'
import PatientStatsDetail from '@/pages/patient-stats/_patient_id/_page_type/Index.vue'

import Exercises from '@/pages/exercises/Index.vue'
import ExercisesDetail from '@/pages/exercises/_exercise_id/Index.vue'
import ExercisesReport from '@/pages/exercises/report/_patient_id/Index.vue'
import PatientsSummaries from '@/pages/patients-summaries/Index.vue'

import SiteStatsDetail from '@/pages/site-stats/_site_stats_id/Index.vue'

import LiveDashboard from '@/pages/live-dashboard/Index.vue'
import AllMetricsLive from '@/pages/all-mertics-live/Index.vue'

import SleepPeriods from '@/pages/sleep-periods/:patient_id/Index.vue'

import PatientMap from '@/pages/map/Index.vue'

import ExercisePrograms from '@/pages/exercise-programs/Index.vue'
import ExerciseProgramExerciseSession from '@/pages/exercise-programs/_exercise-session_id/Index.vue'
import ExerciseProgramLiveExerciseSession from '@/pages/live-dashboard/exercise-session_id/Index.vue'

import ShiftAndRoundReports from '@/pages/shift-and-round-reports/Index.vue'

import DeviceManagement from '@/pages/device-management/Index.vue'
import AdminSiteManagement from '@/pages/admin-site-management/Index.vue'
import OrgSiteManagement from '@/pages/org-site-management/Index.vue'

import { PATIENT_STATS_PAGE_TYPES } from '@/utils/constants'
import { HOME_PAGE, INCLUDE_DASHBOARDS } from '@/constants/app-variables'
import SiteStats from '@/pages/site-stats/Index.vue'

Vue.use(Router)
const baseUrl = './'
console.log(`Base url is ${baseUrl}`)

let homeComponent
switch (HOME_PAGE.toLowerCase()) {
  case 'home':
    homeComponent = Home
    break
  case 'map':
    homeComponent = Map
    break
  case 'site_stats':
    homeComponent = SiteStats
    break
  default:
    homeComponent = Home
    break
}

export default new Router({
  mode: 'hash', // use hash mode to support s3
  base: baseUrl, // NOTE: DO NOT REMOVE!!!, without this line, VueRouter refuse to work
  routes: [
    {
      path: '/',
      component: AppRoot,
      children: [
        {
          path: '',
          name: 'home',
          component: homeComponent, // INCLUDE_DASHBOARDS ? Home : PatientMap,
        },
        {
          path: '/logout',
          name: 'logout',
          component: Logout,
        },
        {
          path: '/patients',
          name: 'patients',
          component: Patients,
        },
        {
          path: '/patient/:patient_id',
          name: 'detailed-patient',
          component: DetailedPatient,
        },
        {
          path: '/patient/:patient_id/edit',
          name: 'edit-detailed-patient',
          component: EditDetailedPatient,
        },
        {
          // mapping-report-pdf
          path: '/patient-report/:patient_id/:timestamp?',
          name: 'patient-report',
          component: PatientReport,
        },
        {
          path: `/patient-stats/:patient_id/:page_type(${Object.values(PATIENT_STATS_PAGE_TYPES)
            .map(v => v.key)
            .join('|')})`,
          name: 'patient-stats',
          component: PatientStatsDetail,
        },
        {
          path: '/exercises',
          name: 'exercises',
          component: Exercises,
        },
        {
          path: '/exercises/:exercise_id',
          name: 'exercises-detail',
          component: ExercisesDetail,
        },
        {
          path: '/exercises/report/:patient_id/',
          name: 'exercises-report',
          component: ExercisesReport,
        },
        {
          path: '/site-stats/',
          name: 'site-stats',
          component: SiteStats,
        },
        {
          path: '/site-stats/:site_stats_id',
          name: 'site-stats-detail',
          component: SiteStatsDetail,
        },
        {
          path: '/live-dashboard/',
          name: 'live-dashboard',
          component: LiveDashboard,
        },
        {
          path: '/all-metrics-live/',
          name: 'all-metrics-live',
          component: AllMetricsLive,
        },
        {
          path: '/patients-summaries',
          name: 'patients-summaries',
          component: PatientsSummaries,
        },
        {
          path: '/sleep-periods/:patient_id',
          name: 'sleep-periods',
          component: SleepPeriods,
        },
        {
          path: '/map',
          name: 'map',
          component: PatientMap,
        },
        {
          path: '/exercise-programs',
          name: 'exercise-programs',
          component: ExercisePrograms,
        },
        {
          path: '/exercise-program/:program_id/exercise-session/:context',
          name: 'new-exercise-session',
          component: ExerciseProgramExerciseSession,
        },
        {
          path: '/exercise-program/:program_id/exercise-session/:context/:exercise_session_id',
          name: 'edit-exercise-session',
          component: ExerciseProgramExerciseSession,
        },
        {
          path: '/live-dashboard/exercise-program/:program_id/exercise-session/:exercise_session_id',
          name: 'exercise-program-live-exercise-session',
          component: ExerciseProgramLiveExerciseSession,
        },
        {
          path: '/shift-and-round-reports',
          name: 'shift-and-round-reports',
          component: ShiftAndRoundReports,
        },
        {
          path: '/device-management',
          name: 'device-management',
          component: DeviceManagement,
        },
        {
          path: '/admin-site-management',
          name: 'admin-site-management',
          component: AdminSiteManagement,
        },
        {
          path: '/org-site-management',
          name: 'org-site-management',
          component: OrgSiteManagement,
        },
      ],
    },
    /* A fallback route in case no route is matched */
    {
      path: '*',
      name: '404',
      component: Error,
    },
  ],
  scrollBehavior(to, from) {
    if (to.name === 'exercises-detail' && to.params.exercise_id !== from.params.exercise_id) {
      return { x: 0, y: 0 }
    }
    return null
  },
})
